import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import "./Button.css";

// Interfaces
import { IButtonProps, TLoadingPosition } from "./interfaces";

// MUI
import { LoadingButton } from "@mui/lab/";

const getLoadingPosition = (loadingPosition?: TLoadingPosition, endIcon?: ReactNode | null) => {
	if (!loadingPosition) {
		return endIcon ? "end" : "center";
	}
	return loadingPosition;
};

export default function Button(props: Readonly<IButtonProps>) {
	const {
		text = "",
		endIcon = null,
		loadingPosition,
		variant,
		classes,
		bgColor,
		minWidth,
		sx = undefined,
		disabled = false,
		disabledElevation = false,
		loading = false,
		onClick = () => {},
	} = props;

	return (
		<LoadingButton
			endIcon={endIcon}
			variant={variant}
			className={twMerge("!shadow-none", classes)}
			disabled={disabled}
			disableElevation={disabledElevation}
			loading={loading}
			loadingPosition={getLoadingPosition(loadingPosition, endIcon)}
			sx={{ backgroundColor: bgColor, minWidth, ...sx }}
			onClick={onClick}
		>
			{text}
		</LoadingButton>
	);
}
